<template>
    <ui-modal ref="container" :z-index="667" spacing="32px 64px" :width="1120" height="auto">
        <div :class="css.mutations">
            <div :class="css.module" v-if="mode == 'codon'">
                <div :class="css.content" class="font-variable font-bold">{{ $t("ProteinCoordinates") }}：{{ site || "--" }}</div>
                <div :class="css.content" class="font-variable font-bold">{{ $t("AA") }}：{{ name || "--" }}</div>
                <div :class="css.content" class="font-variable font-bold">{{ $t("Codon") }}：{{ codon || "--" }}</div>
            </div>
            <div :class="css.module" v-else>
                <div :class="css.content" class="font-variable font-bold">{{ $t("Position") }}：{{ site || "--" }}</div>
                <div :class="css.content" class="font-variable font-bold">{{ $t("Base") }}：{{ name || "--" }}</div>
            </div>

            <ui-table2 :class="css.table" :data="data" :option="option">
                <template #mutation_mrna="{ data }">
                    <div
                        v-if="data.mutation_mrna && data.mutation_mrna_children.length"
                        :class="[css.children, data.mutation_mrna_children_show && css.show]">
                        <div :class="css.item">
                            <div class="ellipsis">{{ data.mutation_mrna }}</div>
                            <ui-icon name="arrow" :class="css.arrow" @click="data.mutation_mrna_children_show = !data.mutation_mrna_children_show" />
                        </div>
                        <div class="ellipsis" v-for="value in data.mutation_mrna_children">
                            {{ value }}
                        </div>
                    </div>
                    <div class="ellipsis" v-else>{{ data.mutation_mrna }}</div>
                </template>

                <template #mutation_protein="{ data }">
                    <div
                        v-if="data.mutation_protein && data.mutation_protein_children.length"
                        :class="[css.children, data.mutation_protein_children_show && css.show]">
                        <div :class="css.item">
                            <div class="ellipsis">{{ data.mutation_protein }}</div>
                            <ui-icon
                                name="arrow"
                                :class="css.arrow"
                                @click="data.mutation_protein_children_show = !data.mutation_protein_children_show" />
                        </div>
                        <div class="ellipsis" v-for="value in data.mutation_protein_children">
                            {{ value }}
                        </div>
                    </div>
                    <div class="ellipsis" v-else>{{ data.mutation_protein }}</div>
                </template>
                <template #type="{ data }">
                    <div class="ellipsis" :title="data.type">{{ data.tag }}</div>
                </template>

                <template #tools="{ data }">
                    <ui-button size="small" :disabled="!data.is_rna_splicer" @click="methods.prediction(data)">RNA Splicer</ui-button>
                </template>

                <template #codon="{ data }">
                    <div :class="css.codon" v-html="data.codon"></div>
                </template>

                <template #clinvar="{ data }">
                    <template v-if="!data.clinvar">--</template>
                    <ProjectRoute :class="css_normalize.assets" :to="`https://www.ncbi.nlm.nih.gov/clinvar/variation/${data.clinvar}`">
                        {{ data.clinvar }}
                    </ProjectRoute>
                </template>
            </ui-table2>

            <div :class="css.footer">
                <div :class="css.extra" v-if="!visible">
                    <div :class="css.descript">{{ $t("MutationPredictorDesc2") }}</div>
                </div>
                <div :class="css.extra" v-else>
                    <div :class="css.entrances">
                        <div :class="css.entrance">{{ $t("MutationPredictorDesc") }}</div>
                        <div :class="[css.entrance, css_normalize.assets]" @click="methods.next('Pathogenicity-Predictor')">
                            <span>Patho Predictor</span>
                            <ui-icon name="arrow" />
                        </div>
                        <div :class="[css.entrance, css_normalize.assets]" @click="methods.next('RNA-Splicer')">
                            <span>RNA Splicer</span>
                            <ui-icon name="arrow" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ui-modal>
</template>

<script lang="ts" setup>
//* 组件库
import { UiModal, UiTable2, UiButton, UiIcon } from "various-ui";
//* 组件属性
import { ModuleEmitsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性注册
const emits = defineEmits(ModuleEmitsOption);

//* 组合函数
const { refs, nodes, methods, computeds } = useComposable(emits);
const { mode, option } = computeds;
const { open } = methods;
const { container } = nodes;
const { data, site, name, codon, visible } = refs;

//* 组件属性导出
defineExpose({ open });
</script>
